/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class CourseTeacher {
  baseApi = ENV.BASE_API;

  async getCourseTeachersByAcademicCycle(accessToken, academicCycleId, gradeId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE_TEACHER}/${academicCycleId}?gradeId=${gradeId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createCourseTeacher(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE_TEACHER}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateCourseTeacher(accessToken, courseTeacherId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE_TEACHER}/${courseTeacherId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteCourseTeacher(accessToken, courseTeacherId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE_TEACHER}/${courseTeacherId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
